module.exports = __webpack_public_path__ + "static/media/sl.18e65344.svg";